// Lot 675 — croix de fermeture toujours visible : la surface SOUS la croix est-elle sombre ? (fond de la boîte, bandeau,
// visuel…) → la croix passe en clair dans une pastille translucide (CSS `[data-dialog-close][data-on-dark="1"]`).
export const parseRgb = (s) => {
  const m = /rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s/]+([\d.]+%?))?\s*\)/i.exec(String(s || ""));
  if (!m) return null;
  let a = m[4] == null ? 1 : parseFloat(m[4]);
  if (String(m[4] || "").endsWith("%")) a /= 100;
  return { r: +m[1], g: +m[2], b: +m[3], a };
};

// Luminance relative (WCAG) : < 0,35 ≈ fond sombre (le texte « foreground » clair du thème sombre s'y lit, pas un X noir).
export const isDarkColor = (s) => {
  const c = parseRgb(s);
  if (!c || c.a < 0.5) return null;
  const lin = (v) => { const x = v / 255; return x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4; };
  return 0.2126 * lin(c.r) + 0.7152 * lin(c.g) + 0.0722 * lin(c.b) < 0.35;
};

// Première surface opaque sous le centre de `el` (l'élément lui-même exclu) → sombre ? null si indéterminable (jsdom…).
export const isOnDarkSurface = (el) => {
  if (!el || typeof document === "undefined" || typeof document.elementsFromPoint !== "function") return null;
  const r = el.getBoundingClientRect();
  if (!r.width || !r.height) return null;
  const stack = document.elementsFromPoint(r.left + r.width / 2, r.top + r.height / 2).filter((n) => n !== el && !el.contains(n));
  for (const n of stack) {
    const dark = isDarkColor(getComputedStyle(n).backgroundColor);
    if (dark !== null) return dark;
  }
  return null;
};
